import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { ReactComponent as LoadIcon } from "../../../images/loadExampleButton.svg";
import SendIcon from "@mui/icons-material/Send";
import { useLocation, useNavigate } from "react-router-dom";

const TestCoverage = () => {
  const isFormValid = () => {
    return (
      plannedUserStories.trim() !== "" &&
      testedUserStories.trim() !== "" &&
      totalTestCases.trim() !== "" &&
      executedTestCases.trim() !== "" &&
      passedTestCases.trim() !== "" &&
      failedTestCases.trim() !== "" &&
      blockedTestCases.trim() !== "" &&
      deferredTestCases.trim() !== "" &&
      keyObservations.trim() !== "" &&
      openItemsInSprint.trim() !== "" &&
      itemsMovedOutOfSprint.trim() !== "" &&
      selectedGraphType.trim() !== ""
    );
  };

  const location = useLocation();
  const navigate = useNavigate();
  const [plannedUserStories, setPlannedUserStories] = useState("");
  const [testedUserStories, setTestedUserStories] = useState("");
  const [totalTestCases, setTotalTestCases] = useState("");
  const [executedTestCases, setExecutedTestCases] = useState("");
  const [passedTestCases, setPassedTestCases] = useState("");
  const [failedTestCases, setFailedTestCases] = useState("");
  const [blockedTestCases, setBlockedTestCases] = useState("");
  const [deferredTestCases, setDeferredTestCases] = useState("");
  const [keyObservations, setKeyObservations] = useState("");
  const [openItemsInSprint, setOpenItemsInSprint] = useState("");
  const [itemsMovedOutOfSprint, setItemsMovedOutOfSprint] = useState("");
  const [selectedGraphType, setSelectedGraphType] = useState("");

  const [accordionStates, setAccordionStates] = useState({
    testCoverage: true,
  });

  const handleFormLoadDemoExample = (e) => {
    e.stopPropagation();
    // Handle loading demo example logic here
    setPlannedUserStories(
      "User Story 1: As a user, I should be able to login to the application" +
        "\nUser Story 2: As a user, I should be able to view my profile details"
    );
    setTestedUserStories(
      "User Story 1: As a user, I should be able to login to the application"
    );
    setTotalTestCases("10");
    setExecutedTestCases("10");
    setPassedTestCases("8");
    setFailedTestCases("2");
    setBlockedTestCases("0");
    setDeferredTestCases("0");
    setKeyObservations(
      "Key Observation 1: Login functionality is working as expected" +
        "\nKey Observation 2: Profile details are not displayed correctly"
    );
    setOpenItemsInSprint(
      "Open Item 1: Profile details are not displayed correctly"
    );
    setItemsMovedOutOfSprint(
      "Item Moved 1: Profile details are not displayed correctly"
    );
    setSelectedGraphType("bar");
  };

  const handleTestCoverageNext = () => {
    // Handle next button click logic here
    try {
      console.log("Next button clicked");

      let testCoverageData = {
        plannedUserStories: plannedUserStories,
        testedUserStories: testedUserStories,
        totalTestCases: totalTestCases,
        executedTestCases: executedTestCases,
        passedTestCases: passedTestCases,
        failedTestCases: failedTestCases,
        blockedTestCases: blockedTestCases,
        deferredTestCases: deferredTestCases,
        keyObservations: keyObservations,
        openItemsInSprint: openItemsInSprint,
        itemsMovedOutOfSprint: itemsMovedOutOfSprint,
        selectedGraphType: selectedGraphType,
      };
      console.log(testCoverageData);
      navigate("/dashboard/sprint-summary-report/output", {
        state: { ...location.state, testCoverageData: testCoverageData },
      });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <CommonAccordion
      summary={
        <Box
          display="flex"
          alignItems="center"
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography variant="subtitle1" sx={{ fontSize: "16px" }}>
            Test Coverage
          </Typography>
          {accordionStates.testCoverage && (
            <Button
              variant="text"
              startIcon={<LoadIcon />}
              sx={{
                ml: 2,
                textTransform: "none",
                position: "relative",
                top: "0px",
              }}
              onClick={handleFormLoadDemoExample}
            >
              Load Demo Example
            </Button>
          )}
        </Box>
      }
      details={
        <Box>
          <Typography>User Story Detail</Typography>
          <TextField
            fullWidth
            label="Planned User Stories"
            margin="normal"
            multiline
            rows={4}
            sx={{ width: "95%" }}
            placeholder="Enter Planned User Stories"
            value={plannedUserStories}
            onChange={(e) => setPlannedUserStories(e.target.value)}
          />
          <TextField
            fullWidth
            label="Tested User Stories"
            margin="normal"
            multiline
            rows={4}
            sx={{ width: "95%" }}
            placeholder="Enter Tested User Stories"
            value={testedUserStories}
            onChange={(e) => setTestedUserStories(e.target.value)}
          />

          <Typography sx={{ mt: 2, mb: 2 }}>Test Execution Summary</Typography>
          <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2}>
            <TextField
              label="Total Test Cases"
              placeholder=" Enter Test Cases"
              fullWidth
              sx={{ width: "90%" }}
              value={totalTestCases}
              onChange={(e) => setTotalTestCases(e.target.value)}
            />
            <TextField
              label="Executed Test Cases"
              placeholder="Enter Executed Cases"
              fullWidth
              sx={{ width: "90%" }}
              value={executedTestCases}
              onChange={(e) => setExecutedTestCases(e.target.value)}
            />
            <TextField
              label="Passed Test Cases"
              placeholder="Enter Passed Cases"
              fullWidth
              sx={{ width: "90%" }}
              value={passedTestCases}
              onChange={(e) => setPassedTestCases(e.target.value)}
            />
            <TextField
              label="Failed Test Cases"
              placeholder="Enter Failed Cases"
              fullWidth
              sx={{ width: "90%" }}
              value={failedTestCases}
              onChange={(e) => setFailedTestCases(e.target.value)}
            />
            <TextField
              label="Blocked Test Cases"
              placeholder="Enter Blocked Cases"
              fullWidth
              sx={{ width: "90%" }}
              value={blockedTestCases}
              onChange={(e) => setBlockedTestCases(e.target.value)}
            />
            <TextField
              label="Deferred Test Cases"
              placeholder="Enter Deferred Cases"
              fullWidth
              sx={{ width: "90%" }}
              value={deferredTestCases}
              onChange={(e) => setDeferredTestCases(e.target.value)}
            />
          </Box>

          <Typography sx={{ mt: 3, mb: 1 }}>Select Graph Type</Typography>
          <RadioGroup
            row
            defaultValue="bar"
            value={selectedGraphType}
            onChange={(e) => setSelectedGraphType(e.target.value)}
          >
            {["bar", "line", "pie"].map((type) => (
              <Box
                key={type}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  width: "137px",
                  height: "40px",
                  marginRight: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  value={type}
                  control={<Radio />}
                  label={
                    type === "bar"
                      ? "Bar Chart"
                      : type === "line"
                      ? "Line Chart"
                      : "Pie Chart"
                  }
                />
              </Box>
            ))}
          </RadioGroup>

          <TextField
            fullWidth
            label="Key Observations"
            placeholder="Enter Key Observations"
            margin="normal"
            multiline
            sx={{ width: "95%" }}
            value={keyObservations}
            onChange={(e) => setKeyObservations(e.target.value)}
          />
          <TextField
            fullWidth
            label="Open Items in Sprint"
            placeholder="Enter Items in Sprint"
            margin="normal"
            multiline
            sx={{ width: "95%" }}
            value={openItemsInSprint}
            onChange={(e) => setOpenItemsInSprint(e.target.value)}
          />
          <TextField
            fullWidth
            label="Items Moved Out of Sprint"
            placeholder="Enter Moved Out of Sprint"
            margin="normal"
            multiline
            sx={{ width: "95%" }}
            value={itemsMovedOutOfSprint}
            onChange={(e) => setItemsMovedOutOfSprint(e.target.value)}
          />
        </Box>
      }
      buttons={[
        {
          label: "Next",
          variant: "contained",
          startIcon: <SendIcon />,
          onClick: handleTestCoverageNext,

          sx: {
            float: "right",
            textTransform: "none",
            backgroundColor: isFormValid() ? "#49A3FF" : "grey",
            color: isFormValid() ? "white" : "black",
            "&:hover": {
              backgroundColor: isFormValid() ? "#49A3FF" : "darkgrey",
            },
          },
          disabled: !isFormValid(),
        },
      ]}
    />
  );
};

export default TestCoverage;
